// extracted by css-extract-rspack-plugin
export default {"Container":"WaVL9","SwapAffordance":"HQ7ra","visible":"WoJTN","SwapAffordanceIcon":"dbFlV"};